<script setup>
import { GA } from '@/mixins/Ga.js';
import WaveTop from '@/icons/wave-top.svg';
import WaveCurve from '@/icons/wave-curve.svg';
import { setUri } from '@/mixins/Commons.js';
import Card from '@/components/card/Card.vue';
import wysiwyg from '@/components/wysiwyg/Wysiwyg.vue';

const ga = new GA({ category: 'endBody', action: 'clicInterne' });
const props = defineProps({
    posts: {
        type: Array,
        default: () => [],
    },
    titleTop: {
        type: String,
        default: '',
    },
    color: {
        type: String,
        default: 'dark-blue',
    },
    cta: {
        type: String,
        default: '',
    },
    ctaLink: {
        type: [String, Object],
        default: '',
    },
    ctaTarget: {
        type: String,
        default: '',
    },
    ctaColor: {
        type: String,
        default: 'dark-blue',
    },
    bg: {
        type: String,
        default: 'dark-blue',
    },
    align: {
        type: String,
        default: 'left',
    },
    tag: {
        type: Boolean,
        default: false,
    },
    text: {
        type: String,
        default: '',
    },
});

const parsedLink = setUri({
    uri: props.ctaLink,
});
</script>
<template>
    <div
        v-if="posts && posts.length"
        class="FeaturedGrid relative pt-12 print:hidden sm:pt-18 md:pt-0 xl:mt-12 xl:pb-12"
    >
        <div
            class="FeaturedGrid__title relative z-10 mb-4 px-6 text-left xl:px-20"
            :class="{
                'ml-auto md:text-right': align == 'right',
                'md:mb-10': !text,
            }"
        >
            <!--
                    md:text-white
                    md:text-bright-blue
                    md:text-light-blue md:text-dark-blue
                    md:text-light-green md:text-dark-green
                    md:text-light-red md:text-dark-red
                    md:text-light-yellow md:text-dark-yellow
                    md:text-light-indigo md:text-dark-indigo
                    md:text-light-orange md:text-dark-orange
                -->
            <h2
                class="h2 text-white"
                :class="['md:text-' + color]"
            >
                {{ titleTop }}
            </h2>
        </div>
        <div
            v-if="text"
            class="FeaturedGrid__text relative z-10 mb-4 px-6 text-white md:mb-10 xl:px-20"
            :class="['md:text-' + color]"
        >
            <wysiwyg
                class="h5"
                :center="false"
                :space="false"
                :data="{ data: { wysiwyg: text } }"
            />
        </div>

        <div class="FeaturedGrid__lower relative z-10">
            <div
                class="FeaturedGrid__posts relative z-10 flex flex-wrap gap-y-4 px-6 pb-6 text-white md:gap-x-[6%] lg:gap-x-[5%] xl:px-20"
                :class="[bg.startsWith('dark') ? 'md:text-white' : 'md:text-light-' + color]"
            >
                <template
                    v-for="post in posts"
                    :key="'cardpost' + post.uri"
                >
                    <Card
                        class="w-full md:w-[47%] lg:w-[30%]"
                        :post="post"
                        :color="color"
                        :tag="tag"
                    />
                </template>
            </div>
            <div
                v-if="parsedLink"
                class="FeaturedGrid__bottom relative z-10 flex justify-center px-6 pb-16 text-center xl:px-20"
            >
                <a
                    v-if="parsedLink && typeof parsedLink == 'string' && parsedLink.startsWith('http')"
                    class="block whitespace-nowrap"
                    :href="parsedLink"
                    :target="ctaTarget"
                >
                    <Btn
                        :text="cta"
                        size="small"
                        class="w-full text-white"
                        :class="['bg-' + ctaColor]"
                    />
                </a>
                <router-link
                    v-else
                    class="whitespace-nowrap"
                    :to="parsedLink"
                    :target="ctaTarget"
                    v-on:click="ga.send({ label: gaLabel })"
                >
                    <Btn
                        :text="cta"
                        size="small"
                        class="w-full text-white"
                        :class="['bg-' + ctaColor]"
                    />
                </router-link>
            </div>

            <div
                aria-hidden
                class="FeaturedGrid__background-md absolute bottom-0 left-0 z-0 hidden h-full w-full md:block md:h-[calc(100%-7rem)] lg:h-[calc(100%-5rem)] xl:h-[calc(100%-8rem)]"
                :class="['bg-' + bg]"
            >
                <WaveTop
                    class="absolute top-0 h-auto w-full translate-y-[-15%] rotate-180 fill-current"
                    :class="['text-' + bg]"
                />
            </div>
        </div>
        <div
            aria-hidden
            class="FeaturedGrid__background-xs absolute bottom-0 left-0 z-0 h-[calc(100%+2px)] w-full md:hidden"
            :class="['bg-' + bg]"
        >
            <WaveCurve
                class="absolute top-px h-auto w-full -translate-y-full fill-current sm:top-[2px]"
                :class="['text-' + bg]"
            />
        </div>
    </div>
    <div v-else><span /><!--FeaturedGrid empty --></div>
</template>
